let module = angular.module('app.resources');

module.factory('User', ($resource) => {
  'ngInject';
  const User = $resource(
    `${API_ROOT}/user`,
    { accountId: '@accountId' },
    {
      get: {
        method: 'GET',
        transformResponse: (data) => {
          const user = angular.fromJson(data);
          if (!user.metadata) {
            user.metadata = {};
          }
          return user;
        },
      },
      update: {
        method: 'PUT',
      },
      updatePassword: {
        method: 'PUT',
        url: `${API_ROOT}/user/password`,
      },
      resendEmailVerification: {
        method: 'POST',
        url: `${API_ROOT}/user/resend_email_verification`,
      },
      switchAccount: {
        method: 'POST',
        url: `${API_ROOT}/user/switch_account/:accountId`,
      },
      validateEmail: {
        method: 'POST',
        url: `${API_ROOT}/checkout/validate_email`,
      },
      getContact: {
        method: 'GET',
        url: `${API_ROOT}/user/contact`,
      },
      updateContact: {
        method: 'PUT',
        url: `${API_ROOT}/user/contact`,
      },
    }
  );
  angular.extend(User.prototype, {
    can: function (action, resource) {
      const possibleActions = (this._capsByResource || {})[resource] || [];
      return possibleActions.some((possibleAction) => action === possibleAction);
    },
    cannot: function (action, resource) {
      return !this.can(action, resource);
    },
    configureCapabilities: function (capsByResource) {
      this._capsByResource = capsByResource;
    },
    reloadFromResource: function (reloadedResource) {
      Object.keys(reloadedResource).forEach((k) => {
        this[k] = reloadedResource[k];
      });
    },
  });
  return User;
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/user.js